
import React from 'react';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Sparkles } from 'lucide-react';

export const PerksFormHeader: React.FC = () => {
  return (
    <CardHeader>
      <div className="flex items-center">
        <Sparkles className="h-5 w-5 text-redflags-red mr-2" />
        <CardTitle>Company Perks</CardTitle>
      </div>
      <CardDescription>
        Add the best perks your company offers to attract top talent
      </CardDescription>
    </CardHeader>
  );
};
